module.exports = __webpack_public_path__ + "img/monitorEquipment_checked.d3ba9a53.png";